import React, { useState, useEffect } from "react";
import "./BusinessOneCaresoul.scss";

const BusinessOneCaresoul = () => {
  const images = [
    "https://images.unsplash.com/photo-1551782450-a2132b4ba21d", // Burger
    "https://images.unsplash.com/photo-1543353071-873f17a7a088", // Food table
    "https://images.unsplash.com/photo-1528605248644-14dd04022da1", // Dining ambience
  ];

  const [current, setCurrent] = useState(0);

  // Auto slide every 5 seconds for a slower, more dramatic pace
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section className="carousel_parent">
      {images.map((image, index) => (
        <div
          key={index}
          className={`carousel_slide ${current === index ? "active" : ""}`}
        >
          <img src={image} alt={`Dining Slide ${index + 1}`} />
        </div>
      ))}

      <div className="carousel_dots">
        {images.map((_, index) => (
          <span
            key={index}
            className={`dot ${current === index ? "active" : ""}`}
            onClick={() => setCurrent(index)}
          ></span>
        ))}
      </div>
    </section>
  );
};

export default BusinessOneCaresoul;